import { GET_FITCATEGORYNEW_REQUEST, GET_FITCATEGORYNEW_SUCCESS, GET_FITCATEGORYNEW_ERROR } from "../actions/types";


export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_FITCATEGORYNEW_REQUEST:
            return {
                loading: true,
            };
        case GET_FITCATEGORYNEW_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_FITCATEGORYNEW_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}